import Loader from 'react-loader-spinner'
import React from "react"

const LoaderSpinner = ({ visible }) => {
    return (
        <Loader
            visible={visible}
            type="Oval"
            color="#165b00"
            height={56}
            width={56}
            timeout={100000} //3 secs

        />
    );
}

export default LoaderSpinner